// Import the plugins
import Uppy from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import {defaults} from 'lodash-es';
import AzureUploader from './AzureUploader';

// And their styles (for UI plugins)
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

export default function (selector, options) {
  const defaultOptions = {
    // This should be overridden by the client code. I'm putting a default just so we know
    // what the client code should look like
    onSuccessfulUpload(name, remoteUrl) {
      // eslint-disable-next-line no-console
      console.log(`${name} was uploaded successfully and can be found at ${remoteUrl}`);
    }
  };
  defaults(options, defaultOptions);

  return Uppy(
    {
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ['image/*', '.pdf', '.vcf'],
        maxFileSize: 1024 * 1024 * 3, // 3 MB
      }
    })
    .use(Dashboard, {
      proudlyDisplayPoweredByUppy: false,
      trigger: selector,
      closeAfterFinish: true,
      note: 'Attach image, PDF, or contact card (VCF)',
      locale: {
        strings: {
          uploadXFiles: {
            0: 'Attach %{smart_count} file',
            1: 'Attach %{smart_count} files'
          },

        }
      }
    })
    .use(AzureUploader, {
      tokenUrl: options.tokenUrl,
    })
    .on('complete', (result) => {
      options.onSuccessfulUpload(result.successful[0].name, result.successful[0].response);
    });
}
